import { render, staticRenderFns } from "./editRequirementForm.vue?vue&type=template&id=39c27094&"
import script from "./editRequirementForm.vue?vue&type=script&lang=ts&"
export * from "./editRequirementForm.vue?vue&type=script&lang=ts&"
import style0 from "./editRequirementForm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports